import { formatDateToUTC2 } from "./date";

const formatSecondFormDataForPDF = (formattedData2, selectedProject) => {
  formattedData2[0].elements[0].value = selectedProject?.nameSurname || "";
  formattedData2[0].elements[1].value = selectedProject?.vocation || "";
  formattedData2[0].elements[2].value = selectedProject?.department?.name || "";
  formattedData2[0].elements[3].value = selectedProject?.email || "";
  formattedData2[0].elements[4].value =
    selectedProject?.mobilePhoneNumber || "";
  formattedData2[0].elements[5].value =
    selectedProject?.workTimeThisPercentage || "";
  formattedData2[0].elements[6].value =
    selectedProject?.workTimeOtherPercentage || "";
  formattedData2[0].elements[7].value =
    selectedProject?.teamLeaderNote || "nema napomena";

  formattedData2[1].elements[0].value = selectedProject?.projectTitle || "";
  formattedData2[1].elements[1].value =
    selectedProject?.projectTitleEnglish || "";
  formattedData2[1].elements[2].value = selectedProject?.projectAcronym || "";
  formattedData2[1].elements[3].value =
    formatDateToUTC2(selectedProject?.applicationDeadline) || "";

  formattedData2[2].elements[0].value = selectedProject?.projectSummary || "";

  formattedData2[3].elements[0].value = selectedProject?.applicationURL || "";

  formattedData2[4].elements[0].value = selectedProject?.sourceOfFunding || "";

  formattedData2[5].elements[0].value = selectedProject?.projectType || "";

  formattedData2[6].elements[0].value =
    formatDateToUTC2(selectedProject?.expectedProjectBeginning) || "";

  formattedData2[7].elements[0].value =
    selectedProject?.expectedProjectDurationInMonths || "";

  formattedData2[8].elements[0].value = selectedProject?.projectApplicant || "";

  formattedData2[9].elements[0].value = selectedProject?.projectPartners || "";

  formattedData2[10].elements[0].value =
    selectedProject?.economicSubjectInvolvement ? "Da" : "Ne";

  formattedData2[11].elements[0].value = `${selectedProject?.totalValue} EUR`;

  formattedData2[12].elements[0].value = `${selectedProject?.fesbValuePart} EUR`;
  formattedData2[12].elements[1].value = `${selectedProject?.currentPersonnelExpense} EUR`;
  formattedData2[12].elements[2].value = `${selectedProject?.newPersonnelExpense} EUR`;
  formattedData2[12].elements[3].value = selectedProject?.indirectExpenses
    ? `${selectedProject.indirectExpenses} EUR`
    : "0 EUR";
  formattedData2[12].elements[4].value = `${selectedProject?.equipmentDescriptionAndExpense} EUR`;
  formattedData2[12].elements[5].value = `${selectedProject?.equipmentAmortizationExpense} EUR`;

  formattedData2[12].elements[6].equipmentsExpenses =
    selectedProject?.equipmentsExpenses || "nema";

  formattedData2[12].elements[7].value =
    selectedProject?.equipmentStorageLocation || "nema";
  formattedData2[12].elements[8].value = `${selectedProject?.otherServicesExpense} EUR`;
  formattedData2[12].elements[9].value = `${selectedProject?.travelRegistrationEducationExpense} EUR`;
  formattedData2[12].elements[10].value =
    selectedProject?.expenseNote || "nema napomene";

  formattedData2[13].elements[0].value = `${selectedProject?.partnerExpense} EUR`;

  formattedData2[13].elements[1].projectPartnersExpenses =
    selectedProject?.projectPartnersExpenses || "nema";

  formattedData2[14].elements[0].value = `${selectedProject?.downPayment} EUR`;

  formattedData2[15].elements[0].value = `${selectedProject?.personalFinancingExpense}`;

  formattedData2[16].elements[0].value = selectedProject?.newEmploymentBoolean
    ? "Da"
    : "Ne";

  formattedData2[17].elements[0].value =
    selectedProject?.newEmploymentsWorkspace || "nema";

  formattedData2[17].elements[1].newEmploymentPositions =
    selectedProject?.newEmploymentPositions?.length > 0
      ? selectedProject?.newEmploymentPositions
      : "nema";
  formattedData2[17].elements[1].title = "NOVA RADNA MJESTA";

  formattedData2[18].elements[0].projectTeam =
    selectedProject?.projectTeam?.length > 0
      ? selectedProject?.projectTeam
      : "nema";
  formattedData2[18].elements[0].title = "PROJEKTNI TIM";

  formattedData2[19].elements[0].value = selectedProject?.consultantServices
    ? "Da"
    : "Ne";

  if (selectedProject?.consultantServices) {
    formattedData2[19].elements[1].title = "TROŠAK KONZULTANTSKE POMOĆI";
    formattedData2[19].elements[1].value = `${selectedProject?.consultantExpense} EUR`;

    formattedData2[19].elements[2].title = "IZVOR KONZULTANTSKE POMOĆI";
    formattedData2[19].elements[2].value =
      selectedProject?.consultantExpenseSource;
  } else {
    formattedData2[19].elements[1].title = "";
    formattedData2[19].elements[1].value = "";

    formattedData2[19].elements[2].title = "";
    formattedData2[19].elements[2].value = "";
  }

  return formattedData2;
};

export default formatSecondFormDataForPDF;
